export default __webpack_public_path__ + "static/media/rotaract club.9fda2c1a.png";